module.exports = __webpack_public_path__ + "static/media/andre-leite.6eb30aca.webp";